"use strict";
exports.__esModule = true;
exports.UserType = void 0;
var UserType;
(function (UserType) {
    UserType["IN_NETWORK"] = "inNetwork";
    UserType["OUT_OF_NETWORK"] = "outOfNetwork";
    UserType["FLEX_ANYWHERE"] = "flexAnywhere";
    UserType["INACTIVE"] = "inactive";
})(UserType = exports.UserType || (exports.UserType = {}));
